import { render, staticRenderFns } from "./ChannelLimits.vue?vue&type=template&id=20736526&scoped=true"
import script from "./ChannelLimits.vue?vue&type=script&lang=js"
export * from "./ChannelLimits.vue?vue&type=script&lang=js"
import style0 from "./ChannelLimits.vue?vue&type=style&index=0&id=20736526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20736526",
  null
  
)

export default component.exports